"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasChildItems(item) {
    return item && item.hasDescendants;
}
exports.default = hasChildItems;
